<template>
  <layout>
    <div>
      <b-card>
        <b-container>
          <b-row>
            <h4 class="card-title mb-0">New Payment</h4>
          </b-row>
          <br />
          <b-row>
            <b-col md="10">
              <b-form @submit.prevent="pay" @reset="clearFields">
                <b-row>
                  <b-col>
                    <b-input-group prepend="Select a member" class="mt-3">
                      <b-form-input
                        v-model="barcode"
                        @keyup="searchCustomerByBarCode"
                      ></b-form-input>
                      <b-input-group-append>
                        <b-button variant="info" @click="searchCustomer"
                          ><i class="fa fa-search mr-1" />Search</b-button
                        >
                      </b-input-group-append>
                    </b-input-group>
                  </b-col>
                </b-row>
                <br />

                <b-row>
                  <h5 class="ml-2">{{ this.selectedMemberName }}</h5>
                </b-row>
                <br />

                <b-row>
                  <b-col>
                    <b-form-group
                      label="Payment for"
                      label-for="groupSelect"
                      :label-cols="3"
                      :horizontal="true"
                    >
                      <b-form-select
                        id="paymentFor"
                        ref="paymentFor"
                        v-model="paymentFor"
                        class="form-control round"
                        @change="paymentForchange"
                        validate
                        required
                      >
                        <option value="null">Select payment for</option>
                        <option value="membership">Gym Membership</option>
                        <option value="zumba">Zumba</option>
                        <option value="product">Product</option>
                        <option value="other">Other</option>
                      </b-form-select>
                    </b-form-group>
                  </b-col>
                </b-row>

                <b-row
                  v-if="paymentFor == 'membership' || paymentFor == 'zumba'"
                >
                  <b-col>
                    <b-form-group
                      label="Payment for"
                      label-for="groupSelect"
                      :label-cols="3"
                      :horizontal="true"
                    >
                      <b-form-select
                        id="memberType"
                        ref="memberType"
                        v-model="memberType"
                        class="form-control round"
                        @change="memberTypechange"
                        validate
                        required
                      >
                        <option value="null">Select membership</option>
                        <option value="1">Mothly</option>
                        <option value="2">3 months</option>
                        <option value="3">6 months</option>
                        <option value="4">12 months</option>
                      </b-form-select>
                    </b-form-group>
                  </b-col>
                </b-row>

                <b-row>
                  <b-col cols="12">
                    <b-form-group
                      label="Remarks"
                      label-for="remarks"
                      :label-cols="3"
                      :horizontal="true"
                    >
                      <b-form-input
                        id="remarks"
                        type="text"
                        v-model="remarks"
                        placeholder="Enter Remarks Here"
                        required
                        validate
                      />
                    </b-form-group>
                  </b-col>
                </b-row>

                <b-row>
                  <b-col cols="12">
                    <b-form-group label="Payment Type">
                      <b-form-radio
                        v-model="paymentType"
                        name="some-radios"
                        value="cash"
                        >Cash</b-form-radio
                      >
                      <b-form-radio
                        v-model="paymentType"
                        name="some-radios"
                        value="card"
                        >Card</b-form-radio
                      >
                    </b-form-group>
                  </b-col>
                </b-row>

                <div v-if="paymentType == 'card'">
                  <b-row>
                    <b-col cols="6">
                      <b-form-group
                        label="Card Type"
                        label-for="groupSelect"
                        :label-cols="3"
                        :horizontal="true"
                      >
                        <b-form-select
                          id="cardtype"
                          ref="cardtype"
                          v-model="cardType"
                          class="form-control round"
                          validate
                          required
                        >
                          <option value="null">Select Card</option>
                          <option value="membership">Visa</option>
                          <option value="product">Master</option>
                          <option value="other">Amex</option>
                          <option value="other">Other</option>
                        </b-form-select>
                      </b-form-group>
                    </b-col>
                    <b-col cols="6">
                      <b-form-group
                        label="Card Number"
                        label-for="groupSelect"
                        :label-cols="3"
                        :horizontal="true"
                      >
                        <b-form-input
                          id="card number"
                          type="number"
                          v-model="cardNumber"
                          placeholder="Enter Card Number"
                        />
                      </b-form-group>
                    </b-col>
                  </b-row>

                  <b-row>
                    <b-col cols="6">
                      <b-form-group
                        label="Bank"
                        label-for="bank"
                        :label-cols="3"
                        :horizontal="true"
                      >
                        <b-form-select
                          id="bank"
                          ref="bank"
                          v-model="bank"
                          class="form-control round"
                          validate
                          required
                        >
                          <option value="null">Select Bank</option>
                          <option value="Commercial bank">
                            Commercial Bank
                          </option>
                          <option value="Seylan bank">Seylan Bank</option>
                          <option value="Sampath bank">Sampath Bank</option>
                          <option value="HNB">HNB</option>
                          <option value="Other">Other</option>
                        </b-form-select>
                      </b-form-group>
                    </b-col>
                    <b-col cols="6"> </b-col>
                  </b-row>
                </div>

                <b-row>
                  <b-col cols="6">
                    <b-form-group
                      label="Amount"
                      label-for="amount"
                      :label-cols="3"
                      :horizontal="true"
                    >
                      <b-form-input
                        id="amount"
                        type="number"
                        v-model="amount"
                        required
                        validate
                      />
                    </b-form-group>
                  </b-col>
                  <b-col cols="6">
                    <b-form-group
                      label="Next Due Date"
                      label-for="nextDuedate"
                      :label-cols="4"
                      :horizontal="true"
                    >
                      <b-form-input
                        id="nextDuedate"
                        type="date"
                        v-model="nextDuedate"
                        required
                        validate
                      />
                    </b-form-group>
                  </b-col>
                </b-row>

                <br />

                <div slot="footer">
                  <b-button
                    :disabled="isProcessing"
                    class="mr-2"
                    type="submit"
                    size="sm"
                    variant="success"
                  >
                    <i class="fa fa-money" /> Pay
                  </b-button>
                  <b-button type="reset" size="sm" variant="danger">
                    <i class="fa fa-ban" /> Reset
                  </b-button>
                </div>
              </b-form>
            </b-col>
          </b-row>
        </b-container>
      </b-card>

      <b-container>
        <b-modal
          id="modifire-modal"
          class="modal-primary"
          size="lg"
          hide-header
          hide-footer
          v-model="primaryModal"
          style="max-width: 70% !important"
        >
          <div id="loading-screen" v-if="isLoading">
            <div class="spinner"></div>
          </div>
          <div v-else>
            <b-row>
              <b-col>
                <b-input-group>
                  <b-form-input
                    ref="barcodeTextField"
                    v-model="filterBarcode"
                    placeholder="Type/Scan barcode"
                    type="number"
                    @keyup="seachbyBarcode()"
                    title="Type in a name"
                  />
                </b-input-group>
              </b-col>
              <b-col>
                <b-input-group>
                  <b-form-input
                    v-model="filter"
                    placeholder="Type name to Search"
                    type="text"
                    @keyup="seachbyName()"
                    title="Type in a name"
                  />
                </b-input-group>
              </b-col>
              <b-col>
                <b-input-group>
                  <b-form-input
                    v-model="filterNIC"
                    placeholder="Type NIC to Search"
                    type="text"
                    @keyup="seachbyNIC()"
                    title="Type in a name"
                  />
                </b-input-group>
              </b-col>
            </b-row>
          </div>

          <b-row class="mt-2">
            <div style="height: 75vh; width: 100%; overflow: auto">
              <table class="table table-striped" id="TableList">
                <thead>
                  <tr>
                    <th scope="col">Barcode</th>
                    <th scope="col">First Name</th>
                    <th scope="col">Last Name</th>
                    <th scope="col">NIC</th>
                    <th scope="col">Mobile No.</th>
                    <!-- <th scope="col">Mobile No. 2</th> -->
                    <th scope="col">Status</th>
                    <th scope="col">Options</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(member, index) in members" :key="member._id">
                    <td>
                      {{ member.barcode == undefined ? '-' : member.barcode }}
                    </td>

                    <td>{{ member.first_name }}</td>
                    <td>{{ member.last_name }}</td>
                    <td>{{ member.nic_no }}</td>
                    <td>{{ member.mobile_no }}</td>
                    <!-- <td>{{ member.mobile_no_2 }}</td> -->
                    <td>{{ member.status }}</td>
                    <td>
                      <b-button
                        :key="member._id"
                        class="btn btn-info btn-md"
                        @click="selectMember(member)"
                      >
                        <i class="cui-ok" />
                        Select
                      </b-button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </b-row>
        </b-modal>
      </b-container>
    </div>
  </layout>
</template>
<script>
import Layout from '@layouts/main'
import uuidv4 from 'uuid/v4'

import { memberMethods, paymentMethods } from '@state/helpers'
import { first } from 'lodash'

export default {
  name: 'newMembers',
  components: {
    Layout,
  },
  page: {
    title: 'Create Members',
  },
  computed: {},
  watch: {},
  data() {
    return {
      memberName: '',
      memberID: '',
      remarks: '',
      paymentFor: null,
      paymentType: 'cash',
      cardType: null,
      cardNumber: '',
      bank: null,
      amount: 0,
      showcardContent: false,
      currentDate: new Date(),
      primaryModal: false,
      members: [],
      selectedMember: null,
      filter: null,
      filterNIC: null,
      filterBarcode: null,
      nextDuedate: new Date(),
      memberType: null,
      isLoading: false,
      isProcessing: false,
      barcode: '',
      selectedMemberName: '',
    }
  },
  mounted() {
    this.loadAllMembers()
    this.nextDuedate = this.formattedDate()
  },
  methods: {
    ...memberMethods,
    ...paymentMethods,
    paymentForchange() {
      if (this.paymentFor !== 'membership') {
        this.nextDuedate = this.formattedDate()
      }
    },
    memberTypechange() {
      debugger
      if (this.memberType == 1) {
        const date = this.currentDate
        const year = date.getFullYear()
        const month = String(date.getMonth() + 2).padStart(2, '0') // Months are zero-based
        const day = String(date.getDate()).padStart(2, '0')

        this.nextDuedate = `${year}-${month}-${day}`
      } else if (this.memberType == 2) {
        const date = this.currentDate
        const year = date.getFullYear()
        const month = String(date.getMonth() + 4).padStart(2, '0') // Months are zero-based
        const day = String(date.getDate()).padStart(2, '0')

        this.nextDuedate = `${year}-${month}-${day}`
      } else if (this.memberType == 3) {
        const date = this.currentDate
        const year = date.getFullYear()
        const month = String(date.getMonth() + 7).padStart(2, '0') // Months are zero-based
        const day = String(date.getDate()).padStart(2, '0')

        this.nextDuedate = `${year}-${month}-${day}`
      } else if (this.memberType == 4) {
        const date = this.currentDate
        const year = date.getFullYear() + 1
        const month = String(date.getMonth() + 1).padStart(2, '0') // Months are zero-based
        const day = String(date.getDate()).padStart(2, '0')

        this.nextDuedate = `${year}-${month}-${day}`
      } else {
        this.nextDuedate = this.formattedDate()
      }
    },
    async loadAllMembers() {
      this.isLoading = true
      let response = await this.getAllMembers()
      if (response.docs.length > 0) {
        this.members = response.docs
      }
      this.isLoading = false
    },
    formattedDate() {
      const date = this.currentDate
      const year = date.getFullYear()
      const month = String(date.getMonth() + 1).padStart(2, '0') // Months are zero-based
      const day = String(date.getDate()).padStart(2, '0')

      return `${year}-${month}-${day}`
    },
    searchCustomer() {
      this.primaryModal = true
      this.filter = null
      this.filterNIC = null
      this.filterBarcode = null
      this.$refs.barcodeTextField.focus()
    },
    selectMember(member) {
      debugger
      this.selectedMember = member
      this.memberName = member.first_name + ' ' + member.last_name
      this.selectedMemberName = this.memberName
      this.memberID = member._id

      this.primaryModal = false
    },
    async pay() {
      if (this.isProcessing) return

      this.isProcessing = true
      try {
        let invoiceNumnber = await this.generateInvoiceNumber()
        debugger
        let payobj = {
          _id: 'payment_' + uuidv4(),
          type: 'payment',
          invoice_number: invoiceNumnber.toString(),
          member_id: this.memberID,
          member_name: this.memberName,
          remarks: this.remarks,
          payment_type: this.paymentFor,
          payment_details: {
            payment_type: this.paymentType,
            card_type: this.cardType,
            card_number: this.cardNumber,
            bank: this.bank,
            amount: this.amount,
          },
          payment_date: this.formattedDate(),
        }
        let resp = await this.doPayment({ paymentDetails: payobj })
        if (resp.ok) {
          alert('Payment Complete')
          if (this.paymentFor == 'membership') {
            this.selectedMember.last_payment_date = this.formattedDate()
            this.selectedMember.next_payment_date = this.nextDuedate
            //update members
            await this.createMembers({ memberDetails: this.selectedMember })
          }

          this.$router.push({
            name: 'invoice',
            params: {
              memberDetails: this.selectedMember,
              paymentDetails: payobj,
            },
          })
        } else {
          alert('Payment failed')
        }
      } catch (error) {
        console.error('Payment error:', error)
        alert('An error occurred during payment. Please try again.')
      } finally {
        this.isProcessing = false
      }
    },
    async generateInvoiceNumber() {
      let q = {
        selector: {
          type: 'payment',
          payment_date: {
            $gte: this.formattedDate(),
          },
        },
        limit: 10000000,
      }
      let response = await this.getPaymentForcurrentDate(q)
      debugger
      if (response.docs.length > 0) {
        debugger
        let res = response.docs.sort(
          (a, b) => b.invoice_number - a.invoice_number
        )
        let newinvoiceId = parseInt(res[0].invoice_number) + 1
        return newinvoiceId
      } else {
        const date = this.currentDate
        const year = date.getFullYear().toString().slice(-2)
        const month = String(date.getMonth() + 1).padStart(2, '0') // Months are zero-based
        const day = String(date.getDate()).padStart(2, '0')

        return `${year}${month}${day}0001`
      }
    },
    clearFields() {
      this.firstName = ''
      this.lastName = ''
      this.address = ''
      this.mobileNo = null
      this.mobileNo2 = null
      this.gender = null
      this.nic = ''
      this.joined_date = ''
      this.last_payment_date = ''
      this.status = 'Active'
    },
    seachbyName() {
      var input, filter, table, tr, td, i, txtValue
      filter = this.filter.toUpperCase()
      table = document.getElementById('TableList')
      tr = table.getElementsByTagName('tr')
      for (i = 0; i < tr.length; i++) {
        td = tr[i].getElementsByTagName('td')[1]
        if (td) {
          txtValue = td.textContent || td.innerText
          if (txtValue.toUpperCase().indexOf(filter) > -1) {
            tr[i].style.display = ''
          } else {
            tr[i].style.display = 'none'
          }
        }
      }
    },
    seachbyNIC() {
      var input, filter, table, tr, td, i, txtValue
      input = document.getElementById('myInput')
      filter = this.filterNIC.toUpperCase()
      table = document.getElementById('TableList')
      tr = table.getElementsByTagName('tr')
      for (i = 0; i < tr.length; i++) {
        td = tr[i].getElementsByTagName('td')[3]
        if (td) {
          txtValue = td.textContent || td.innerText
          if (txtValue.toUpperCase().indexOf(filter) > -1) {
            tr[i].style.display = ''
          } else {
            tr[i].style.display = 'none'
          }
        }
      }
    },

    seachbyBarcode() {
      var input, filter, table, tr, td, i, txtValue
      input = document.getElementById('myInput')
      filter = this.filterBarcode.toUpperCase()
      table = document.getElementById('TableList')
      tr = table.getElementsByTagName('tr')
      for (i = 0; i < tr.length; i++) {
        td = tr[i].getElementsByTagName('td')[0]
        if (td) {
          txtValue = td.textContent || td.innerText
          if (txtValue.toUpperCase().indexOf(filter) > -1) {
            tr[i].style.display = ''
          } else {
            tr[i].style.display = 'none'
          }
        }
      }
    },
    async searchCustomerByBarCode() {
      if (this.barcode.length >= 4) {
        let findmember = this.members.find(x => x.barcode == this.barcode)
        if (findmember !== undefined) {
          await this.selectMember(findmember)
        }
      } else {
        this.selectedMemberName = ''
      }
    },
  },
}
</script>

<style >
.modal-dialog {
  max-width: 70%; /* Adjust the width as needed */
}

#loading-screen {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
}

.spinner {
  border: 10px solid #f3f3f3;
  border-top: 10px solid #ecc22e;
  border-radius: 50%;
  width: 100px;
  height: 100px;
  animation: spin 2s linear infinite;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>
